import React from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const bonuses = [{
    icon: '🎯',
    title: 'Ventas y Psicología',
    desc: 'Prompts que convencen y cierran'
  }, {
    icon: '🎬',
    title: 'Guiones Virales',
    desc: 'Scripts que detienen el scroll'
  }, {
    icon: '✍️',
    title: 'Copywriting',
    desc: 'Posts, captions y carrousels'
  }, {
    icon: '📈',
    title: 'Conversión Directa',
    desc: 'Transforma seguidores en clientes'
  }, {
    icon: '🤖',
    title: 'Ingeniería de Agentes',
    desc: 'Crea tu GPT personalizado'
  }, {
    icon: '🚀',
    title: 'Lanzamiento y Validación',
    desc: 'Testea sin perder tiempo'
  }];
  return <section className="py-28 px-6 bg-gradient-to-br from-[#0D0800] to-[#1A0F00] text-center" data-id="element-50">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="bg-gradient-to-br from-[rgba(255,215,0,0.08)] to-[rgba(255,107,0,0.05)] border-2 border-[rgba(255,215,0,0.3)] rounded-3xl p-10 sm:p-[60px] max-w-[700px] mx-auto relative overflow-hidden" data-id="element-51">
        <span className="inline-block bg-gold text-dark px-6 py-2 rounded-full font-black text-[14px] mb-6 tracking-[1px]" data-id="element-52">
          🎁 BONO EXCLUSIVO INCLUIDO
        </span>
        <h2 className="text-[clamp(24px,4vw,40px)] font-black mb-4 text-gold" data-id="element-53">
          La Librería de Oro
        </h2>
        <p className="text-[18px] text-[#CCCCCC] mb-10 leading-[1.7]" data-id="element-54">
          50 Prompts Nivel Maestro listos para copiar y pegar.
          <br data-id="element-55" />
          Organizados en 15 categorías especializadas.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-left" data-id="element-56">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[rgba(255,215,0,0.05)] border border-[rgba(255,215,0,0.15)] rounded-xl p-4" data-id="element-57">
              <span className="text-[24px] mb-2 block" data-id="element-58">{bonus.icon}</span>
              <h4 className="text-[14px] font-bold text-gold mb-1" data-id="element-59">
                {bonus.title}
              </h4>
              <p className="text-[12px] text-[#888]" data-id="element-60">{bonus.desc}</p>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}